<template>
  <div :class="reminderRibbonClass" id="reminderRibbon">
    <div class="reminder-ribbon-label" id="reminderRibbonLabel">
      <span id="labelSpan" style="font-size: 10px !important;">FOLLOW UP AT</span>
      <p class="text-center" style="font-size: 16px !important;height: 20px">{{ followUpTime }}</p>
    </div>
  </div>
</template>

<script>
import { Tool } from '@/util/index'
const tool = new Tool()
export default {
  name: 'follow-up-reminder',
  props: {
    loan: Object,
    followUpInfo: Object
  },
  data () {
    return {
      followUpTime: '--:--:--',
      reminderRibbonClass: 'reminder-ribbon-red'
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    followUpInfo: {
      handler: function () {
        this.getFollowUpData()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    const $this = this
    let timer = setInterval(function () {
      const currentTime = tool.formatDateTime(new Date().getTime())
      if (currentTime > $this.followUpTime) {
        $this.reminderRibbonClass = 'reminder-ribbon-blue'
        clearInterval(timer)
        timer = null
      }
    }, 1000)
    $this.$once('hook:beforeDestroy', () => {
      clearInterval(timer)
      timer = null
    })
  },
  methods: {
    getFollowUpData () {
      const $this = this
      $this.followUpTime = $this.followUpInfo.followUpAt
      const currentTime = tool.formatDateTime(new Date().getTime())
      if (currentTime > $this.followUpTime) {
        $this.reminderRibbonClass = 'reminder-ribbon-blue'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .reminder-ribbon-red {
    border-top-right-radius: 6px;
    display: block;
    position: relative;
    float: right;
    background-color: #f8463f;
    color: white;
    opacity: 0.88;
    top: -6px;
    margin-right: 10px;
    .reminder-ribbon-label {
      right: 0;
      p {
        margin: 0;
      }
      span {
        position: relative;
        display: inline-block;
        text-align: center;
        background: #f8463f;
        font-size: inherit;
        line-height: 1;
        padding: 8px 8px 0px;
        border-top-right-radius: 8px;
        width: 170px;
      }
      span:before {
        background: #f8463f;
        height: 6px;
        width: 6px;
        left: -6px;
        top: 0;
      }
      span:after {
        background: #c02031;
        height: 6px;
        width: 8px;
        border-radius: 8px 8px 0 0;
        left: -8px;
        top: 0;
      }
      span:before, span:after {
        position: absolute;
        content: '';
        display: block;
      }
    }
    .reminder-ribbon-label:after {
      position: absolute;
      content: '';
      display: block;
      width: 0;
      height: 0;
      border-left: 85px solid transparent;
      border-right: 85px solid transparent;
      border-top: 10px solid #f8463f;
    }
  }
  .reminder-ribbon-blue {
    border-top-right-radius: 6px;
    display: block;
    position: relative;
    float: right;
    background-color: #03a9f4;
    color: white;
    opacity: 0.88;
    top: -6px;
    margin-right: 10px;
    .reminder-ribbon-label {
      right: 0;
      p {
        margin: 0;
      }
      span {
        position: relative;
        display: inline-block;
        text-align: center;
        background: #03a9f4;
        font-size: inherit;
        line-height: 1;
        padding: 8px 8px 0px;
        border-top-right-radius: 8px;
        width: 170px;
      }
      span:before {
        background: #03a9f4;
        height: 6px;
        width: 6px;
        left: -6px;
        top: 0;
      }
      span:after {
        background: #005da0;
        height: 6px;
        width: 8px;
        border-radius: 8px 8px 0 0;
        left: -8px;
        top: 0;
      }
      span:before, span:after {
        position: absolute;
        content: '';
        display: block;
      }
    }
    .reminder-ribbon-label:after {
      position: absolute;
      content: '';
      display: block;
      width: 0;
      height: 0;
      border-left: 85px solid transparent;
      border-right: 85px solid transparent;
      border-top: 10px solid #03a9f4;
    }
  }
</style>
